import { TextField, TextFieldProps } from '@mui/material'
import * as React from 'react'
import { PatternFormat, PatternFormatProps } from 'react-number-format'

export type MaskedInputProps = Omit<PatternFormatProps, 'size'> & TextFieldProps
/**
 * Base component for constructing inputs that follow particular formats - in general,
 * you should not need to render this component directly, but instead provide a wrapper
 * that 'standardizes' the mask for things like currency, phone numbers, etc.
 */
export const MaskedInput = ({ onChange, name, type = 'text', ...props }: MaskedInputProps) => (
  <PatternFormat
    // InlineInput's `color` props is a subset of string
    // @ts-expect-error the customInput prop is broadening the `color` type to `string`
    customInput={TextField}
    onValueChange={({ value: v }, { event }) => {
      // remove leading '1' if present, remove characters after the 10th digit
      const cleanedValue = type === 'tel' && typeof v === 'string' ? v.replace(/^1+/, '') : v
      onChange?.({
        ...event,
        target: { name, value: cleanedValue } as unknown as HTMLInputElement,
      } as React.ChangeEvent<HTMLInputElement>)
    }}
    name={name}
    {...props}
    type={type}
  />
)
